/**
 * Shared auth configuration.
 *
 * Lives apart from apolloClient.tsx so that tokenStore can reach the endpoint without
 * importing the Apollo client — tokenStore is imported *by* apolloClient, and a cycle
 * there would be evaluated at module load.
 */
export const GRAPHQL_URL = 'https://simple.tamulaitis.com/graphql';

export const STORAGE_KEYS = {
  /** The refresh token. The access token is deliberately kept in memory only. */
  REFRESH_TOKEN: 'ramioda-refresh-token',
  /**
   * Non-sensitive marker saying "this browser had a session, and it was good until X".
   * Never holds a token. Used to decide whether to boot into INITIALISING (and show a
   * spinner) rather than flashing a signed-out UI at a returning customer, and as the
   * cross-tab signal for sign-in/sign-out.
   */
  AUTH_HINT: 'ramioda-auth-hint',
  /** WooCommerce session, already used by the anonymous cart. */
  WOO_SESSION: 'woo-session',
} as const;

/**
 * Treat a token as expired this many seconds early, to absorb clock skew between the
 * browser and WordPress. Never used to *authorise* anything — only to decide when to
 * refresh proactively. The server remains the authority.
 */
export const EXPIRY_SKEW_SECONDS = 30;

/** Operations that must never trigger the refresh-and-retry path. See errorLink. */
export const AUTH_OPERATION_NAMES = ['Login', 'RefreshToken', 'RegisterCustomer'];
